import { defineStore } from 'pinia';
import { deepCopy } from '@/tool/format';
export const useBacthStore = defineStore('bacth', {
  state: () => {
    return {
      //批次表单
      batchData: {
        batchId: '',
        batchCode: '',
        remark: '',
        variety: '',
        stage: '',
        state: '',
        initiaSpec: '',
        targetSpec: '',
        uploadFiles: [],
        _uploadFiles: [],
      },
      //新增批次表单
      resetData: {
        autoGenerated: '0',
        batchCode: '',
        variety: '',
        varietyId: '',
        stage: '',
        stageId: '',
        initiaSpec: '',
        targetSpec: '',
        remark: '',
        uploadFiles: [],
        _uploadFiles: [],
        breedingRecordRequests: { fishpondRequests: [] },
      },
      //新增批次表单
      saveData: {
        autoGenerated: '0',
        batchCode: '',
        variety: '',
        varietyId: '',
        stage: '',
        stageId: '',
        initiaSpec: '',
        targetSpec: '',
        remark: '',
        uploadFiles: [],
        _uploadFiles: [],
        breedingRecordRequests: { fishpondRequests: [], _fishpondRequests: [] },
      },

      // 鱼池数据
      fishpondData: {
        recordId: '',
        fishpondId: '',
        fishpondCode: '',
        weight: '',
        initiaQuantity: '',
        initiaSpec: '',
        submitDate: '',
        submitUser: '',
        uploadFiles: [],
      },

      //分筛转移数据
      sievingData: {
        transferId: '',
        batchId: '',
        batchCode: '',
        submitUser: '',
        submitDate: '',
        remark: '',
        createTime: '',
        submitDate: '',
        createBy: '',
        recordRequests: [],
        uploadFiles: [],
        _uploadFiles: [],
      },

      //分筛数据
      sievingForm: {
        recordId: '',
        fishpondId: '',
        fishpondCode: '',
        currQuantity: '',
        afterCount: '',
        specification: '',
        transferCount: '',
        toFishpondId: '',
        toFishpondCode: '',
        createTime: '',
        createBy: '',
        uploadFiles: [],
        _uploadFiles: [],
      },

      //查看数据
      checkData: {
        systemId: '',
        systemCode: '',
        batchId: '',
        batchCode: '',
        fishpondId: '',
        fishpondCode: '',
        submitUser: '', //操作人
        submitDate: '', //操作日期
        uploadFiles: [], //附件
        _uploadFiles: [], //附件
        remark: '',

        //投放数据
        recordId: '',
        weight: '',
        initiaQuantity: '',
        currQuantity: '',

        //分筛数据
        transferId: '',
        beforeCount: '', //分筛前数量
        afterCount: '', //分筛后数量
        specification: '', //分筛规格
        transferCount: '',

        //出鱼数据
        shippingId: '',
        shippingCount: '', //出鱼数量
        shippingWeight: '', //出鱼重量
        shippingSpec: '', //出鱼规格
        targetSpec: '', //目标规格
      },
    };
  },
  actions: {
    reset() {


      // this.resetData.saveData = {
      //   autoGenerated: '0',
      //   batchCode: '',
      //   variety: '',
      //   varietyId: '',
      //   stage: '',
      //   stageId: '',
      //   initiaSpec: '',
      //   targetSpec: '',
      //   remark: '',
      //   uploadFiles: [],
      //   _uploadFiles: [],
      //   breedingRecordRequests: { fishpondRequests: [] },
      // };
      this.saveData = {
        autoGenerated: '0',
        batchCode: '',
        variety: '',
        varietyId: '',
        stage: '',
        stageId: '',
        initiaSpec: '',
        targetSpec: '',
        remark: '',
        uploadFiles: [],
        _uploadFiles: [],
        breedingRecordRequests: { fishpondRequests: [] },
      };

      console.log('1111', this.saveData);
    },
    resetSievingObjec() {
      this.resetData.sievingData = {
        transferId: '',
        batchId: '',
        batchCode: '',
        submitUser: '',
        submitDate: '',
        remark: '',
        createTime: '',
        submitDate: '',
        createBy: '',
        recordRequests: [],
        uploadFiles: [],
        _uploadFiles: [],
      };
      this.sievingData = this.saveData.sievingData;
    },
  },
  getters: {
    getBachObj(state) {
      return state.batchData;
    },
    getBachObject(state) {
      console.log(' state.saveData--再次读取', state.saveData);
      return state.saveData;
    },
    getSievingObject(state) {
      return deepCopy(state.sievingData);
    },
    getCheckObject(state) {
      return state.checkData;
    },
  },
  // persist: true,
});
